// api.js

import axiosInstance from '../axiosInstance'

export const shippingServiceService = {
  create: async (serviceData) => {
    try {
      let response = await axiosInstance.post('/shipping-service', {
        ...serviceData
      })
      return response.data
    } catch (error) {
      throw error
    }
  },

  fetch: async (limit, skip, clientId, searchValue) => {
    try {
      let response = await axiosInstance.get(
        `/shipping-service?$limit=${limit || 50}&$skip=${skip || 0}&${
          clientId ? `client_id=${clientId}` : ''
        }`
      )
      return response.data
    } catch (error) {
      throw error
    }
  },

  edit: async (serviceData, id) => {
    try {
      let response = await axiosInstance.patch(`/shipping-service/${id}`, {
        ...serviceData
      })
      return response.data
    } catch (error) {
      throw error
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/shipping-service/${id}`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}
